import { FormControl, FormHelperText, styled } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { colors } from "@zapalacorp/tokens";

import Checkbox from "../Checkbox";

export const HeaderWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const Title = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "24px",
  // Aware of the use of the variable, we change it when we use the new kit design
  color: colors.brandBlue500,
}));

export const RequiredLabel = styled("span")(() => ({
  color: colors.error500,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "20px",
  letterSpacing: "0.1px",
  marginLeft: "2px",
}));

export const Description = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "16px",
  letterSpacing: "0.4px",
}));

export const StyledFormControl = styled(FormControl)(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
}));

interface IStyledCheckboxWrapper {
  direction?: "row" | "column";
}

export const StyledCheckboxWrapper = styled("div")(
  ({ direction = "row" }: IStyledCheckboxWrapper) => ({
    display: "flex",
    justifyContent: "space-between",
    flexDirection: direction,
  })
);

export const StyledCheckbox = styled(Checkbox)(() => ({
  "& > span": {
    alignItems: "center",
    display: "flex",
  },

  "&:hover": {
    background: "transparent",
  },
}));

export const StyledFormHelperText = styled(FormHelperText)(() => ({
  fontFamily: "Manrope",
  fontStyle: "normal",
  fontWeight: "normal",
  fontSize: "14px",
  lineHeight: "24px",
  color: colors.error600,
  alignItems: "center",
  display: "flex",
  margin: 0,
}));

export const InfoOutlinedIcon = styled(InfoOutlined)(() => ({
  marginRight: "5px",
  fontSize: "16px",
}));
